export interface QuickProjectPersistence<TPayload> {
  id: string | undefined;
  payload: TPayload;
  isValid: (payload: TPayload) => boolean;
  update: (id: string, payload: TPayload) => Promise<void>;
  create: (payload: TPayload) => Promise<string>;
}

/** Runs the same create/update decision used by Quick Estimate without a create fallback after update failure. */
export async function persistQuickProject<TPayload>(input: QuickProjectPersistence<TPayload>): Promise<string> {
  if (!input.isValid(input.payload)) {
    throw new Error('Nie można zapisać projektu: niepoprawny zapis szybkiej wyceny.');
  }
  if (input.id !== undefined) {
    await input.update(input.id, input.payload);
    return input.id;
  }
  return input.create(input.payload);
}
